import { useEffect, useState } from 'react'
import { ExpandMore ,Info } from '@mui/icons-material'
import { useSection } from '../../../context/section'
import { useProject } from '../../../context/project'
import { Skeleton, Button, Typography, Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import InsightProgressBar from '../../InsightProgressBar'
import DeepCorrelationModal from '../../deep-correlation/components/DeepCorrelationModal'
import useCorrelation from '../components/hooks/useCorrelation'
import { useGraphContext } from '../../../context/graphContext'
import Tooltip from '../../Tooltip'
import { mainGraphColorNames } from '../../../utils/constants'
import "./InsightPanel.scss"

export default function InsightPanel() {
    const { correlation } = useGraphContext()
    const { sectionDataset } = useSection()
    const { privateCompany, ticker } = useProject()
    const { financialInfo, dataset } = sectionDataset
    const [openInsights, setOpenInsights] = useState(true)
    const [openModal, setOpenModal] = useState(false)
    const [selectedDataset, setSelectedDataset] = useState('')
    const [loading, setloading] = useState(true)
    // const {loading, correlation} = useCorrelation(dataset, ticker, privateCompany, financialInfo)
    // const [correlation,setcorrelation] = useState(correlation)
    
    useEffect(()=>{
        setloading(false)
        return () => {}
    },[correlation])
    const expandModal = (index) => {
        setSelectedDataset(dataset[index])
        setOpenModal(true)
    } 
    const isCorrelationExpanded = () => setOpenInsights(!openInsights)
    const newValue = (correlationValue) => ((correlationValue + 1) / 2) * 100
    const gridItem = (columnName, i, columnValue) => ( 
       <>
            <div className="data-set">
                <Button disableRipple variant="contained" color={mainGraphColorNames[i]}/>
                <Typography color={mainGraphColorNames[i]}>{columnName}</Typography>
            </div>
            {correlation?.length>0&&correlation[i]&&<InsightProgressBar label={(correlation[i][columnValue])*100} percent={newValue(correlation[i][columnValue])} tag={{'':'-100%'}} secondTag={{'':'100%'}} />}
      </>
    )

    const correlationDetails = (columnName, i, columnValue) => (
        <Grid item className="grid-item"  key={`${columnName} ${i}`} onClick = {(e)=>{expandModal(i)}}>
            {loading ? (<Skeleton variant="rect" width={116} height={90}/>) : ( gridItem(columnName, i, columnValue) )}
        </Grid>
    )
 
    const renderInsight = () => (
        <Grid container className="grid-container" >
            {dataset?.map(({ columnName,columnValue }, i) => {
                return(correlationDetails(columnName, i, columnValue))})}
            {openModal && <DeepCorrelationModal 
                setOpenModal={setOpenModal} 
                openModal={openModal} 
                selectedDataset={selectedDataset}
                setSelectedDataset={setSelectedDataset}>
            </DeepCorrelationModal>}
        </Grid>
    )
      
    const tooltipTitle =<Typography className='tooltip-title'>{`Correlation is done after de-trending of the data. The de-trended data may be viewed by using the display method: Change (%).`}<br/><br/> 
    {`If an aggregation method is not chosen, the correlation will be calculated by the average quarterly aggregation of the alternative data.`}</Typography>

    const correlationAccordion = () => (
        <div className='accordion-container'>
            <Accordion className='accordion' square defaultExpanded={true} expanded={openInsights}>
                <div className='correlations-close'>
                    <AccordionSummary expandIcon={<ExpandMore color="textPrimary" />} onClick={isCorrelationExpanded}/> 
                    <p className="button-text">Correlations</p>
                    <Tooltip title={tooltipTitle}>
                        <Info color='icon'/>
                    </Tooltip>
                </div>
                <AccordionDetails className='accordion-details'>
                    {renderInsight()}
                </AccordionDetails>
            </Accordion>
      </div>
    )

    return correlationAccordion()
}